import FileSelector from './file-selector';

export default FileSelector;
